<ng-template #afterTitle>
    <app-switch-input id="active" [form]="controlsForm" label="folderMedication.inactive"></app-switch-input>
</ng-template>

<ng-template #buttons>
    <app-button icon="pi-print" severity="secondary" label="database.persons.printButton" class="white-space-nowrap"
        (clickEvent)="printMedication()"
    ></app-button>
    <app-button icon="pi-print" severity="secondary" label="folderMedication.printForClient" class="white-space-nowrap"
        (clickEvent)="printMedication(true)"
    ></app-button>
</ng-template>

<app-table
    #medicationTable
    translatePrefix="folderMedication."
    [columns]="columns"
    [gridData]="store.gridData()"
    [buttons]="buttons"
    [afterTitle]="afterTitle"
    [refreshCallback]="store.api.getFolderMedications"
    [refreshCallbackFragment]="getMedicationsFrag"
    [showCreate]="store.isAllowed('folderMedication.create')()"
    (createCallback)="detail()"
    (detailCallback)="detail($event)"
    (deleteCallbackWithEvent)="delete($event)"
    [showDelete]="store.isAllowed('folderMedication.delete')()"
    [showButtonLabels]="true"
    [additionalFilter]="extraFilters()"
    [rowExpansion]="(this.store.medicationSettings()?.showColumnTimesAdministrated ?? true) ? rowExpansion : null"
>
    <ng-template pTemplate="active" let-item="item">
            <span
                class="pi pi-circle-fill cursor-pointer"
                [ngClass]="{
                    'green': item.active,
                    'orange': item.activeOutOfDate,
                }"
                [pTooltip]="item.activeOutOfDate ? ('folderMedication.message.activeOutOfDate' | translate) : undefined"
                (click)="$event.stopPropagation(); changeState(item)"
            ></span>
    </ng-template>

    <ng-template pTemplate="stock" let-item="item">
        <span
            [ngClass]="(item | countDaysDiff) <= 0 ? 'red' : ((item | countDaysDiff) < 7 ? 'orange' : '')"
        >
            {{ (item | countDaysDiff) | formatDaysDiff }}
        </span>
    </ng-template>

    <ng-template pTemplate="medicationCode" let-data="data" let-item="item">
        @if (item.customMedication) {
            {{ item.customMedicationName }}
        } @else {
            <app-medication-info
                #medInfos
                [medicationCode]="data"
            ></app-medication-info>
        }
    </ng-template>

    <ng-template #rowExpansion let-item="item">
        <app-folder-medications-works [medication]="item"></app-folder-medications-works>
    </ng-template>
</app-table>
